module.exports = __webpack_public_path__ + "static/media/certificate-2016.054f7024.jpeg";